
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    export class IcStockApproveDisassembleDtGrid extends Serenity.EntityGrid<IcStockApproveDisassembleDtRow, any> {
        protected getColumnsKey() { return IcStockApproveDisassembleDtColumns.columnsKey; }
        protected getDialogType() { return IcStockApproveDisassembleDtDialog; }
        protected getIdProperty() { return IcStockApproveDisassembleDtRow.idProperty; }
        protected getInsertPermission() { return IcStockApproveDisassembleDtRow.insertPermission; }
        protected getLocalTextPrefix() { return IcStockApproveDisassembleDtRow.localTextPrefix; }
        protected getService() { return IcStockApproveDisassembleDtService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}